// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/main.css
// module id = CuRo
// module chunks = 0